import { render, staticRenderFns } from "./AboutSlider.vue?vue&type=template&id=4a4950d9&scoped=true&"
import script from "./AboutSlider.vue?vue&type=script&lang=js&"
export * from "./AboutSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4950d9",
  null
  
)

export default component.exports